import { render, staticRenderFns } from "./GalleryCard.vue?vue&type=template&id=dbf20d70&scoped=true&"
import script from "./GalleryCard.vue?vue&type=script&lang=ts&"
export * from "./GalleryCard.vue?vue&type=script&lang=ts&"
import style0 from "./GalleryCard.vue?vue&type=style&index=0&id=dbf20d70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf20d70",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsImageOrFallback: require('/var/www/packages/theme/components/atoms/ImageOrFallback.vue').default,MoleculesCmsUrlWrapper: require('/var/www/packages/theme/components/molecules/CmsUrlWrapper.vue').default})
